import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ArrowDown } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './About.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SubNav = function SubNav(_ref) {
  var activeSection = _ref.activeSection,
      arrowIconClass = _ref.arrowIconClass,
      backgroundImageStyle = _ref.backgroundImageStyle,
      forwardedRef = _ref.forwardedRef,
      onSubNavAnchorClick = _ref.onSubNavAnchorClick,
      scrollNext = _ref.scrollNext,
      sections = _ref.sections;
  return /*#__PURE__*/_jsxs("div", {
    className: css.subNav,
    ref: forwardedRef,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.borderTop
    }), /*#__PURE__*/_jsx("ul", {
      className: css.subNavList,
      children: sections.map(function (section, i) {
        if (section.title) {
          var id = section.id,
              numeral = section.numeral,
              title = section.title;
          var titleAnchorClass = cc([css.subNavTitle, _defineProperty({}, css.active, activeSection === i)]);
          return /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsxs("button", {
              "aria-label": "Scroll To ".concat(title, " Section"),
              className: css.subNavLink,
              "data-testid": id,
              id: id,
              name: id,
              onClick: onSubNavAnchorClick,
              type: "button",
              children: [/*#__PURE__*/_jsx("span", {
                className: css.subNavNumeral,
                children: numeral
              }), /*#__PURE__*/_jsx("span", {
                className: titleAnchorClass,
                children: title
              })]
            })
          }, "subNav".concat(id));
        }

        return true;
      })
    }), /*#__PURE__*/_jsx("button", {
      "aria-label": "Scroll To The Next Section",
      className: css.scrollNextBtn,
      onClick: scrollNext,
      type: "button",
      "data-testid": "scroll-next",
      children: /*#__PURE__*/_jsx("div", {
        className: arrowIconClass,
        children: /*#__PURE__*/_jsx(ArrowDown, {})
      })
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.fixedBackgroundBottom, css.fixedBackground]),
      style: backgroundImageStyle
    })]
  });
};

SubNav.propTypes = {
  activeSection: PropTypes.number.isRequired,
  arrowIconClass: PropTypes.string.isRequired,
  backgroundImageStyle: PropTypes.shape({}).isRequired,
  forwardedRef: PropTypes.shape({}).isRequired,
  scrollNext: PropTypes.func.isRequired,
  onSubNavAnchorClick: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape()).isRequired
};
export default SubNav;